(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.countdown-section').forEach(function(section) {
    const endDateStr = section.dataset.endDate;
    const endDate = new Date(endDateStr).getTime();

    function update() {
    const now = new Date().getTime();
    const diff = endDate - now;

    if (diff < 0) {
    section.querySelector(".countdown-box").innerHTML = "Expired";
    return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    section.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
    section.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
    section.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
    section.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
    }

    update();
    setInterval(update, 1000);
    });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
